import { ComponentProps } from "."
import { StyledTag } from "./styled"

const Tag = (props: ComponentProps) => <StyledTag {...props} />

export default Tag
